module.exports = __webpack_public_path__ + "img/text_A.6a565f68.svg";